module.exports = __webpack_public_path__ + "static/media/Law.db294477.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Industries/Law.svg
// module id = 320
// module chunks = 0